export default __webpack_public_path__ + "static/media/ladrillos-consejo.2a48acc9.png";